import type { EmailWithError } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/utils/consts";
import { EMAIL_VALIDATION_ERROR } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/utils/consts";

export const checkEmailInputs = (emailInputs: string[], userEmail: string): EmailWithError[] => {
    const invalidEmails: EmailWithError[] = [];

    const emailRegex =
        /^(?:"[^"\\]*(?:\\.[^"\\]*)*"@|[0-9a-z](?:[.\-!#$%&'*+/=?^_`{|}~\w]*[0-9a-z])@)(?:\[(?:\d{1,3}\.){3}\d{1,3}\]|(?:[0-9a-z][-\w]*[0-9a-z]*\.)+[a-z0-9][\-a-z0-9]{0,22}[a-z0-9])$/i;

    const similarwebRegex = /@similarweb\.com$/i;

    for (const email of emailInputs) {
        if (email.toLowerCase() === userEmail.toLowerCase()) {
            invalidEmails.push({ email, reason: EMAIL_VALIDATION_ERROR.INVITE_YOURSELF });
            continue;
        }

        if (!emailRegex.test(email) || (email.includes("+") && !similarwebRegex.test(email))) {
            invalidEmails.push({ email, reason: EMAIL_VALIDATION_ERROR.WRONG_FORMAT });
        }
    }

    return invalidEmails;
};
